import Observer from '../../../common/scripts/observer';

const observer = new Observer();

class MapFilter {
    /**
     * Базовые свойства
     * @constructor
     */
    constructor() {
        this.buttons = null;
        this.globalFilterState = true;
        this.checkEvent = document.createEvent('HTMLEvents');
        this.checkEvent.initEvent('change', false, true);
        this.list = document.querySelector('.j-infrastructure-list');
    }

    /**
     * Инициализирует плагин
     * @param {Object} outerSettings - настройки из внешнего файла
     */
    init(outerSettings) {
        this.buttons = Array.from(outerSettings.target.querySelectorAll('.j-map-filter-item'));

        this._bindEvents();
    }

    /**
     * Навешивает обработчик клика
     */
    _bindEvents() {
        this.buttons.forEach((button) => {
            button.addEventListener('change', (event) => {
                const mapEvent = button.checked ? 'addFilterItem' : 'removeFilterItem';

                observer.publish('map:hideAllMarkers');
                this._setGlobalFilterState();
                this._changeState(button);
                observer.publish(mapEvent, event.target.dataset.type);
                observer.publish('filterUpdated');
            });
        });
    }

    _setGlobalFilterState() {
        this.globalFilterState = this.buttons.every((button) => {
            return button.checked;
        });
    }

    _changeState(button) {
        const parent = button.closest('.j-infrastructure-map__filter-item');

        if (!parent) {
            return;
        }


        const nowActive = this.list.querySelector('.item-is-active');
        const filterAll = this.list.querySelector('.j-checkbox-toggle');

        if (!filterAll.classList.contains('is-unactive')) {
            filterAll.classList.add('is-unactive');
        }

        if (nowActive) {
            nowActive.querySelector('input').checked = false;
            nowActive.classList.remove('item-is-active');
        }

        if (button.checked) {
            parent.classList.add('item-is-active');
        } else {
            parent.classList.remove('item-is-active');
        }
    }

    changeCheckBoxState() {
        const holdGlobalFilterState = this.globalFilterState;

        this.buttons.forEach((button) => {
            if (button.checked !== holdGlobalFilterState) {
                return;
            }

            button.checked = !button.checked;
            button.dispatchEvent(this.checkEvent);
        });
    }

    showAll(allFilter) {
        if (allFilter.classList.contains('is-unactive')) {
            const nowActive = this.list.querySelector('.item-is-active');

            if (nowActive) {
                nowActive.querySelector('input').checked = false;
                nowActive.classList.remove('item-is-active');
            }

            observer.publish('map:showAllMarkers');

            allFilter.classList.remove('is-unactive');
        }
    }
}

export default MapFilter;
